import { useState } from 'react';
import PositionHistoryTable from 'src/components/HistoryTables/PositionHistoryTable/PositionHistoryTable';
import {
	PORTFOLIO_HISTORY_MARKET_FILTER_ALL_OPTION,
	PORTFOLIO_HISTORY_TABLE_EMPTY_CLASSNAME,
} from 'src/components/PortfolioPage/PortfolioHistorySubPage/consts';
import PortfolioHistoryPositionsTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryPositionsTable/PortfolioHistoryPositionsTableControls';

export default function PortfolioHistoryPositionsTable() {
	const [marketFilter, setMarketFilter] = useState(
		PORTFOLIO_HISTORY_MARKET_FILTER_ALL_OPTION.ticker
	);

	return (
		<div>
			<PortfolioHistoryPositionsTableControls
				marketFilter={marketFilter}
				handleMarketFilterChange={setMarketFilter}
			/>
			<PositionHistoryTable
				tableContentWrapperClassName="not-sm:px-0"
				emptyClassName={PORTFOLIO_HISTORY_TABLE_EMPTY_CLASSNAME}
				marketFilter={marketFilter}
				noExpandAllButton
			/>
		</div>
	);
}
